const GlobalAtomicFieldTypes = [
  { value: 'text', name: 'Text' },
  { value: 'ssn', name: 'Social Security Number' },
  { value: 'email', name: 'Email' },
  { value: 'textarea', name: 'Text Area' },
  { value: 'date', name: 'Soft Date' },
  { value: 'harddate', name: 'Hard Date (Dropdown)' },
  { value: 'dropdown', name: 'Dropdown' },
  { value: 'radio', name: 'Radio' },
  { value: 'checkbox', name: 'Checkbox' },
  { value: 'number', name: 'Number' },
  { value: 'currency', name: 'Currency' },
  { value: 'file', name: 'File' },
  { value: 'altesign', name: 'Additional Signer' },
  { value: 'regex', name: 'Regular Expression' }
]

const GlobalWebhookEventTypes = [
  { value: 'userform', name: 'Form Update' },
  { value: 'to client', name: 'New Outbound Message' },
  { value: 'from client', name: 'New Inbound Message' },
  { value: 'contact file', name: 'New Contact File Upload' },
]

const GlobalRegexPatterns = [
  {
    name: 'US Zip Code',
    validation_message: 'Invalid ZIP Code (Must Be #####)',
    regex_pattern: '^[0-9]{5}?$',
    mask_pattern: '#####'
  },
  {
    name: 'US Phone Number (No Extensions) (###-###-####)',
    validation_message: 'Invalid Phone Number (Must Be ###-###-####); Extensions not accepted',
    regex_pattern: '^[0-9]{3}-[0-9]{3}-[0-9]{4}$',
    mask_pattern: '###-###-####'
  },
  {
    name: 'Custom Pattern'
  }
]

const GlobalStatusStrings = [
  { value: 'new', name: 'New', icon: 'lock_open' },
  { value: 'client started', name: 'Client Started', icon: 'lock_open' },
  { value: 'client signing', name: 'Client Signing (on submission)', icon: 'mdi-signature-freehand', apionly: true },
  { value: 'client submitted', name: 'Client Submitted', icon: 'edit', apionly: true },
  { value: 'in house', name: 'Completing In-House', icon: 'edit' },
  { value: 'under review', name: 'Under Review', icon: 'rate_review' },
  { value: 'deficient', name: 'Deficient', icon: 'thumb_down' },
  { value: 'esign', name: 'Request E-Signature', icon: 'mdi-signature' },
  { value: 'esign declined', name: 'E-Signature Declined', icon: 'mdi-file-document-box-remove', apionly: true },
  { value: 'esign returned', name: 'E-Signature Returned', icon: 'mdi-signature-freehand', apionly: true },
  { value: 'complete', name: 'Complete', icon: 'lock' },
  { value: 'submitted', name: 'Submitted', icon: 'lock' },
  { value: 'not completing', name: 'Not Completing', icon: 'mdi-format-page-break' }
]

function TestAnswerEmpty (answer, fieldType) {
  var passed = true
  if (fieldType.atomic_type === "radio" || fieldType.atomic_type === "dropdown") {
    if (answer.option) {
      passed = false
    }
  } else if (fieldType.atomic_type === "checkbox") {
    if (answer.options && Object.keys(answer.options).length != 0) {
      passed = false
    }
  } else if (fieldType.atomic_type === "number") {
    if (answer.number || answer.number === 0) {
      passed = false
    }
  } else if (fieldType.atomic_type === "date") {
    if (answer.date) {
      passed = false
    }
  } else if (fieldType.atomic_type === "harddate") {
    if (answer.year || answer.month || answer.day) {
      passed = false
    }
  } else if (fieldType.atomic_type === "altesign") {
    if (answer.name || answer.email) {
      passed = false
    }
  } else if (fieldType.atomic_type === "file") {
    if (answer.file) {
      passed = false
    }
  } else {
    if (answer.text && answer.text) {
      passed = false
    }
  }
  return passed
}

function MeetsCondition (part, get_answer, parts) {
  if (part.section) {
    if (!MeetsCondition(parts[part.section], get_answer, parts))
      return false
  }

  if(!part.conditional_question_id) return true
  
  if (MeetsCondition(parts[part.conditional_question_id], get_answer, parts)) {
    var answer = get_answer(part.conditional_question_id, part.conditional_fieldtype_id)
    if(answer) {
      if (answer.string == part.conditional_value)
        return true
      if (answer.string.includes("; ") && answer.string.split("; ").includes(part.conditional_value)) {
        return true
      }
    }
  }
  return false
}

export default {
  AtomicFieldTypes: GlobalAtomicFieldTypes,
  StatusStrings: GlobalStatusStrings,
  TestAnswerEmpty: TestAnswerEmpty,
  GlobalRegexPatterns: GlobalRegexPatterns,
  MeetsCondition: MeetsCondition,
  GlobalWebhookEventTypes: GlobalWebhookEventTypes
}
